import AboutUs from '@pages/admin/all-pages/about-us'
import BookingPolicy from '@pages/admin/all-pages/booking-policy'
import CancellationPolicy from '@pages/admin/all-pages/cancellation-policy'
import PrivacyPolicy from '@pages/admin/all-pages/privacy-policy'
import RefundPolicy from '@pages/admin/all-pages/refund-policy'
import ReschedulePolicy from '@pages/admin/all-pages/reschedule-policy'
import TermsAndConditions from '@pages/admin/all-pages/terms-and-conditions'
import Banner from '@pages/admin/banner-settings/banner-form'
import Bookings from '@pages/admin/bookings'
import CustomerSupport from '@pages/admin/customer-support'
import Dashboard from '@pages/admin/dashboard'
import LocationSetup from '@pages/admin/location-setup'
import PushNotifications from '@pages/admin/push-notifications'
import Notification from '@pages/admin/notifications'
import SystemSettings from '@pages/admin/system-setting'
import Transaction from '@pages/admin/transactions'
import ProviderManagement from '@pages/admin/user-management/providers'
import IndividualProvider from '@pages/admin/user-management/providers/individual-provider'
import IndividualVehicle from '@pages/admin/user-management/providers/individual-provider/vehicles/individual-vehicle'
import UserManagement from '@pages/admin/user-management/users'
import IndividualUser from '@pages/admin/user-management/users/individual-user'
import Amenity from '@pages/admin/amenity-setup'
import NotificationList from '@pages/admin/notifications'
export const adminRoutes = [
  {
    path: 'dashboard',
    Component: Dashboard,
    exact: true,
  },
  {
    path: 'dashboard/home',
    Component: Dashboard,
    exact: true,
  },

  {
    path: 'user-management/users',
    Component: UserManagement,
    exact: true,
  },
  {
    path: 'user-management/users/:id',
    Component: IndividualUser,
    exact: true,
  },
  {
    path: 'user-management/providers',
    Component: ProviderManagement,
    exact: true,
  },
  {
    path: 'user-management/providers/:id',
    Component: IndividualProvider,
    exact: true,
  },
  {
    path: 'transactions',
    Component: Transaction,
    exact: true,
  },
  {
    path: 'user-management/providers/:id/vehicle/:vehicleId',
    Component: IndividualVehicle,
    exact: true,
  },
  {
    path: 'bookings',
    Component: Bookings,
    exact: true,
  },

  {
    path: 'location-setup',
    Component: LocationSetup,
    exact: true,
  },
  {
    path: 'amenity-setup',
    Component: Amenity,
    exact: true,
  },
  {
    path: 'amenity-setup/:params',
    Component: Amenity,
    exact: true,
  },
  {
    path: 'location-setup/:params',
    Component: LocationSetup,
    exact: true,
  },
  {
    path: 'banner-settings',
    Component: Banner,
    exact: true,
  },
  {
    path: 'banner-settings/:params',
    Component: Banner,
    exact: true,
  },
  {
    path: 'push-notifications',
    Component: PushNotifications,
    exact: true,
  },
  {
    path: 'push-notifications/:id',
    Component: PushNotifications,
    exact: true,
  },
  {
    path: 'customer-support',
    Component: CustomerSupport,
    exact: true,
  },
  // {
  //   path: 'customer-support/:params',
  //   Component: CustomerSupport,
  //   exact: true,
  // },

  {
    path: 'system-settings',
    Component: SystemSettings,
    exact: true,
  },
  {
    path: 'all-pages/about-us',
    Component: AboutUs,
    exact: true,
  },
  {
    path: 'all-pages/privacy-policy',
    Component: PrivacyPolicy,
    exact: true,
  },
  {
    path: 'all-pages/termsandconditions',
    Component: TermsAndConditions,
    exact: true,
  },
  {
    path: 'all-pages/refund-policy',
    Component: RefundPolicy,
    exact: true,
  },
  {
    path: 'all-pages/cancellation-policy',
    Component: CancellationPolicy,
    exact: true,
  },
  {
    path: 'all-pages/booking-policy',
    Component: BookingPolicy,
    exact: true,
  },
  {
    path: 'all-pages/reschedule-policy',
    Component: ReschedulePolicy,
    exact: true,
  },
  {
    path: 'notifications',
    Component: NotificationList,
    exact: true,
  },
]
